module.exports = __webpack_public_path__ + "img/temperature-icon-3.3e11f768.svg";